/* @flow */

import { baseColor } from '@e180/ui/lib/token/color';
import { white } from '@e180/ui/lib/token/palette';
import { baseFontFamily } from '@e180/ui/lib/token/typography';

export default {
  label: {
    display: 'block',

    marginBottom: '0.25em',

    color: ({ accentColor }: Object) => accentColor,

    fontSize: 15,
    fontWeight: 700,
    WebkitFontSmoothing: 'antialiased',
  },
  inputCtn: {
    display: 'flex',
    alignItems: 'center',
  },
  select: {
    padding: 0,

    background: 'none',
    border: 'none',
    color: white,

    fontFamily: baseFontFamily,
    fontSize: 14,
    fontWeight: 500,
    WebkitFontSmoothing: 'antialiased',

    '&:focus': {
      outlineWidth: 0,
    },
    '& option': {
      backgroundColor: baseColor,
    },
  },
  icon: {
    color: ({ accentColor }: Object) => accentColor,
    marginLeft: 2,
  },
};
